import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
import {getCart} from './CartHelpers';

import EmptyCart from './EmptyCart'
import CartList from './CartList'
import Navbar1 from '../Layout/Navbar1';
import DefaultHeader from '../Layout/DefaultHeader';


const Cart = (props) => {
    const [items, setItems] = useState([]);
   

    useEffect(() => {
        setItems(getCart());
    }, [items]);//whenever items get from localStorage change this useEffect will run -->realtime getItems from localstorage-->removeItem

    return (
        <React.Fragment>
            <Navbar1/>
            <DefaultHeader/>
        <section>
         {
             ((items.length>0)&&
               (
                   <React.Fragment>
                   <CartList value={items}/>
                 </React.Fragment>
               ))||(<EmptyCart/>)
            }
      </section>
        </React.Fragment>
    );
};

export default Cart;